// src/slices/systemConfiguration/reducer.ts
// Redux slice cho System Configuration — rút gọn, chỉ giữ phần đọc cấu hình (config/loading/error)
// dùng cho Cổng tra cứu kết quả.

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemConfiguration } from '../../pages/SystemConfiguration/types';
import { fetchSystemConfig } from './thunk';

interface SystemConfigState {
  config: SystemConfiguration | null;
  loading: boolean;
  error: string | null;
}

const initialState: SystemConfigState = {
  config: null,
  loading: false,
  error: null,
};

const systemConfigSlice = createSlice({
  name: 'SystemConfiguration',
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<SystemConfiguration>) => {
      state.config = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSystemConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSystemConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setConfig, setLoading, setError, clearError } = systemConfigSlice.actions;

export default systemConfigSlice.reducer;
